import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { Icon } from '../Icon';
import type { CustomIconProps } from './types';

/**
 * Renders a Plus icon with an optional badge.
 *
 * @see Docs https://fontawesome.com/icons/plus?f=classic&s=solid
 */
export const PlusIcon: React.FC<CustomIconProps> = (props) => {
  return <Icon icon={faPlus} {...props} />;
};
